"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CartListItemType = exports.InternalPaymentType = exports.CartItemSource = void 0;
var CartItemSource;
(function (CartItemSource) {
    CartItemSource["LIMITED_TIME_DEAL"] = "LIMITED_TIME_DEAL";
    CartItemSource["COUPON"] = "COUPON";
    CartItemSource["CART"] = "CART";
})(CartItemSource || (exports.CartItemSource = CartItemSource = {}));
var InternalPaymentType;
(function (InternalPaymentType) {
    InternalPaymentType["NONE"] = "NONE";
    InternalPaymentType["COD"] = "COD";
    InternalPaymentType["PREPAID"] = "PREPAID";
})(InternalPaymentType || (exports.InternalPaymentType = InternalPaymentType = {}));
var CartListItemType;
(function (CartListItemType) {
    CartListItemType["CART"] = "CART";
    CartListItemType["FREE_PRODUCT"] = "FREE_PRODUCT";
    CartListItemType["AUTO_FREE_PRODUCT"] = "AUTO_FREE_PRODUCT";
    CartListItemType["AUTO_FREE_PRODUCT_DISABLED"] = "AUTO_FREE_PRODUCT_DISABLED";
    CartListItemType["LIMITED_TIME_DEAL"] = "LIMITED_TIME_DEAL";
})(CartListItemType || (exports.CartListItemType = CartListItemType = {}));
